var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_6.7.3._Vista_general:_Paciente-_Acceso_a_la_consulta_en_estados:_Finalizada",
    "data-name": "6.7.3. Vista general: Paciente- Acceso a la consulta en estados: Finalizada",
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M103.381,139H19.19A16.21,16.21,0,0,1,3,122.81V19.19A16.21,16.21,0,0,1,19.19,3h59.03A16.284,16.284,0,0,1,90.2,8.294l25.16,27.7a16.054,16.054,0,0,1,4.21,10.886V79.16a3.238,3.238,0,1,1-6.476,0V46.876a9.611,9.611,0,0,0-2.516-6.522l-25.17-27.7a9.792,9.792,0,0,0-7.189-3.18H19.19A9.714,9.714,0,0,0,9.476,19.19V122.81a9.714,9.714,0,0,0,9.714,9.714h84.19a3.238,3.238,0,1,1,0,6.476Z",
    transform: "translate(-3 -3)",
    fill: "#1565c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M49.667,47.393H36.714A9.714,9.714,0,0,1,27,37.679V6.658a3.238,3.238,0,0,1,6.476,0V37.679a3.238,3.238,0,0,0,3.238,3.238H49.667a3.238,3.238,0,0,1,0,6.476Z",
    transform: "translate(50.715 -2.06)",
    fill: "#1565c0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M24.69,33.167H14.976A6.476,6.476,0,0,1,8.5,26.69V16.976A6.476,6.476,0,0,1,14.976,10.5H24.69a6.476,6.476,0,0,1,6.476,6.476V26.69A6.476,6.476,0,0,1,24.69,33.167Zm-9.714-16.19V26.69H24.69V16.976Z",
    transform: "translate(9.309 13.786)",
    fill: "#1565c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M24.69,43.167H14.976A6.476,6.476,0,0,1,8.5,36.69V26.976A6.476,6.476,0,0,1,14.976,20.5H24.69a6.476,6.476,0,0,1,6.476,6.476V36.69A6.476,6.476,0,0,1,24.69,43.167Zm-9.714-16.19V36.69H24.69V26.976Z",
    transform: "translate(9.309 36.167)",
    fill: "#1565c0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M42.9,31.476H20.238a3.238,3.238,0,0,1,0-6.476H42.9a3.238,3.238,0,0,1,0,6.476Z",
    transform: "translate(28.334 46.238)",
    fill: "#1565c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M36.429,27.476H20.238a3.238,3.238,0,0,1,0-6.476h16.19a3.238,3.238,0,0,1,0,6.476Z",
    transform: "translate(28.334 37.286)",
    fill: "#1565c0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M24.69,53.167H14.976A6.476,6.476,0,0,1,8.5,46.69V36.976A6.476,6.476,0,0,1,14.976,30.5H24.69a6.476,6.476,0,0,1,6.476,6.476V46.69A6.476,6.476,0,0,1,24.69,53.167Zm-9.714-16.19V46.69H24.69V36.976Z",
    transform: "translate(9.309 58.548)",
    fill: "#1565c0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M42.9,41.476H20.238a3.238,3.238,0,0,1,0-6.476H42.9a3.238,3.238,0,0,1,0,6.476Z",
    transform: "translate(28.334 68.619)",
    fill: "#1565c0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M36.429,37.476H20.238a3.238,3.238,0,0,1,0-6.476h16.19a3.238,3.238,0,1,1,0,6.476Z",
    transform: "translate(28.334 59.667)",
    fill: "#1565c0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M42.9,21.476H20.238a3.238,3.238,0,0,1,0-6.476H42.9a3.238,3.238,0,0,1,0,6.476Z",
    transform: "translate(28.334 23.857)",
    fill: "#1565c0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M36.429,17.476H20.238a3.238,3.238,0,0,1,0-6.476h16.19a3.238,3.238,0,0,1,0,6.476Z",
    transform: "translate(28.334 14.905)",
    fill: "#1565c0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M42.952,56.946A3.238,3.238,0,0,1,40.664,56l-9.715-9.715A3.238,3.238,0,1,1,35.528,41.7l7.208,7.208L56.659,32.207a3.238,3.238,0,1,1,4.974,4.145L45.442,55.78A3.238,3.238,0,0,1,43.1,56.943Z",
    transform: "translate(57.428 59.625)",
    fill: "#1565c0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M57.381,89.762A32.381,32.381,0,1,1,89.762,57.381,32.381,32.381,0,0,1,57.381,89.762Zm0-58.286a25.9,25.9,0,1,0,25.9,25.9A25.9,25.9,0,0,0,57.381,31.476Z",
    transform: "translate(46.238 46.238)",
    fill: "#1565c0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinished);
export default __webpack_public_path__ + "static/media/icon-finished.fc87b5d578c09ec622fcf0f9cff7dc66.svg";
export { ForwardRef as ReactComponent };